import { ERoomType } from '../json_query';

const roomsTitles: { [key: number]: string } = {
  0: 'комнату',
  7: 'своб. план.',
  8: 'долю',
  9: 'студию',
  10: 'койко-место',
};

const shortRoomTitles: { [key: number]: string } = {
  ...roomsTitles,
  7: 'св. пл.',
  9: 'ст.',
};

const roomNames: { [index: number]: string } = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
};

const EM_DASH = '\u2014';

export function getSequences(roomNumbers: string[]) {
  const sortedValues = roomNumbers
    .map(Number)
    .filter(Number)
    .sort();
  let seq: [number, number] = [sortedValues[0], sortedValues[0]];
  const sequences: [number, number][] = [];

  sortedValues.forEach((value, index) => {
    if (index === 0) {
      return;
    } else if (value - 1 === seq[1]) {
      seq[1] = value;
    } else {
      sequences.push(seq);
      seq = [value, value];
    }
  });

  sequences.push(seq);

  return sequences.map(([start, end]) => {
    return start === end ? roomNames[start] : `${roomNames[start]}${end - start > 1 ? EM_DASH : ', '}${roomNames[end]}`;
  });
}

export function formatRoomsLabel(rooms: ERoomType[], useShortLabels?: boolean): string {
  if (!rooms || rooms.length === 0) {
    return 'Комнат';
  }

  let result = '';
  let roomNumbers: string[] = [];
  let otherRooms: string[] = [];

  rooms.forEach(value => {
    switch (value) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        roomNumbers.push(String(value));
        break;
      default:
        otherRooms.push(useShortLabels ? shortRoomTitles[value] : roomsTitles[value]);
    }
  });

  if (roomNumbers.length) {
    const seq = getSequences(roomNumbers);
    result += seq.join(', ') + ' ';
    result += seq.length + otherRooms.length <= 2 ? 'комн.' : 'к.';
  }

  if (otherRooms.length) {
    result += result ? ', ' : '';
    result += otherRooms.join(', ');
  }

  return result ? result[0].toUpperCase() + result.substr(1) : result;
}
